/** Keep in sync with `InAppNarrowExposureCohort` in `@post-office/message-template-contracts`. */
export type NarrowExposureCohort = string | boolean;

/**
 * Narrow exposure experiment config for one message at one placement.
 * Keep in sync with `InAppNarrowExposureExperiment` in `@post-office/message-template-contracts`.
 */
export type NarrowExposureConfig = {
	statsigExperiment: string;
	statsigParameterName: string;
} & (
	| { showCohorts: string[]; dropCohorts: string[] }
	| { showCohorts: boolean[]; dropCohorts: boolean[] }
);

export const NARROW_EXPOSURE_DROP_REASON = 'narrowExposureExperiment' as const;

/**
 * Cohort on the `dropped` event when Statsig returned no usable cohort. A real Statsig parameter
 * value of `unevaluated` can't be told apart from it.
 */
export const UNEVALUATED_COHORT = 'unevaluated' as const;

export type NarrowExposureDecision =
	| { outcome: 'show'; cohort: NarrowExposureCohort }
	| { outcome: 'drop'; cohort: NarrowExposureCohort }
	| { outcome: 'unevaluated' };
